import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

interface TabState {
  selectedTab: string | null;
}

const initialState: TabState = {
  selectedTab: 'legend',
};

const tabSlice = createSlice({
  name: 'tab',
  initialState,
  reducers: {
    selectTab: (state, action) => {
      state.selectedTab = state.selectedTab === action.payload ? null : action.payload;
    },
  },
});

export const { selectTab } = tabSlice.actions;

export const selectSelectedTab = (state: RootState) => state.tab.selectedTab;

export default tabSlice.reducer;